import { Form } from '../../components/Form';
import LogoPedidosForce from '../../../../themes/assets/pedidos_fc.png';
import LogoAda from '../../assets/logo-square.png';
import LogoGA from '../../assets/ga_logo.png';

import { Toaster } from 'react-hot-toast';
import { useModals } from '../../../../contexts/Modals';
import { useEffectOnce } from 'react-use';
import { Typography } from '@material-ui/core';

export const Login = () => {
  const { setShowModalInfo, setShowModalProgress } = useModals();

  useEffectOnce(() => {
    setShowModalInfo(false);
    setShowModalProgress(false);
  })

  return (
    <div className="login-page">
      <div className="login-screen">
        <div className="login-formContainer">
          <img src={LogoGA} alt="Logo Geraldo Araújo" className="logo-client" />
          <Form />
          <Toaster />
        </div>
      </div>
      <img src={LogoPedidosForce} alt="Logo Geraldo Araújo" className="logo-pedidos-force" />
      <div className='logo-ada'>
        <img src={LogoAda} alt="Logo Codapta" />
        <Typography></Typography>
      </div>
    </div>
  );
}